import { render } from "./tabs.vue?vue&type=template&id=420770ed"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=420770ed&lang=css"
script.render = render

export default script